<section class="w-full h-full rounded-lg p-4">
  <!-- ? Header -->
  <header class="w-full px-1 flex justify-end items-center">
      <span (click)="dialogRef.close()"
        class="icon text-lg dismiss-regular cursor-pointer"
      ></span>
  </header>

  <!-- ? Main -->
  <main class="w-full flex flex-wrap justify-center content-center">
    <div class="flex justify-center items-center avatar-xl bg-gray-100 mb-4">
      <img
        class="w-full h-full"
        loading="lazy"
        height="40px"
        width="30px"
        onerror="this.src='https://cloud.behkhaan.ir/assets/images/default/default_challenge.svg'"
        [src]="
          data?.challenge?.id
            | image : imageType.challenge : data?.challenge?.hasPhoto : '.svg'
        "
      />
    </div>
    <div class="w-full flex flex-wrap justify-center text-sm">
      <span class="w-full flex justify-center text-gray-900 mb-2">{{
        text
      }}</span>
      <a
        class="text-green-500"
        matDialogClose="true"
        [routerLink]="[
          routes.challenge_detail,
          data?.challenge?.userChallenges[0]?.id
        ]"
        >مشاهده جزئیات چالش</a
      >
    </div>
  </main>
</section>
